<template>
  <div class="flex flex-col flex-1 justify-center">
    <div class="flex flex-1 justify-center">
      <!-- <span class="hidden sm:flex flex-1 items-center"><DoiLine /></span>
      <DoiHeader class="flex flex-1 justify-center items-center title" :level="3" :headerColor="1" :fontFamily="0">JE RÉSERVE MA SÉANCE</DoiHeader>
      <span class="hidden sm:flex flex-1" /> -->
    </div>
    <PaymentAbstract :readOnly="false" :isCartLoading="isCartLoading" :isOrganizer="true" />
  </div>
</template>

<script>
import PaymentAbstract from '@/views/reglements/PaymentAbstract'
import { mapGetters } from 'vuex'

export default {
  name: 'Payment',
  components: {
    PaymentAbstract
  },
  computed: {
    ...mapGetters('UserModule', ['get_user']),
    ...mapGetters('CartModule', ['get_cart']),
    isCartLoading () {
      return this.$store.getters['CartModule/isCartLoading']
    },
    loading () {
      return this.$store.getters['CartModule/isCartLoading']
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_variables.scss';

.font {
  font-size: 0.75rem;
  font-family: $doi--text-font-family2;
}

@media (max-width: 640px) {
  .title {
    font-size: $doi--header5;
  }
}
</style>
